import { render, staticRenderFns } from "./HighlightedFiaInsightsCard.vue?vue&type=template&id=b907aa8e&scoped=true&"
import script from "./HighlightedFiaInsightsCard.vue?vue&type=script&lang=js&"
export * from "./HighlightedFiaInsightsCard.vue?vue&type=script&lang=js&"
import style0 from "./HighlightedFiaInsightsCard.vue?vue&type=style&index=0&id=b907aa8e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b907aa8e",
  null
  
)

export default component.exports